export default "__VITE_ASSET__DKdePW3M__"